export { useHealthSurveillanceQuestionnaire } from "./useHealthSurveillanceQuestionnaire";
export { useMedicalTypesForAppointment } from "./useMedicalTypesForAppointment";
